/* eslint-disable */
import React, { FC } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import {
  dialogBoxStyle,
  dialogContainedButtonStyle,
  dialogOutlinedButtonStyle,
} from "./dialogStyle";
import Cancel from "@mui/icons-material/Cancel";

type ModalProps = {
  buttonAction: () => void;
  buttonTitle: string;
  error?: boolean;
  setShow: (show: boolean) => void;
  show: boolean;
  title: string;
};

const ConfirmationDialog: FC<ModalProps> = ({
  buttonAction,
  buttonTitle,
  error,
  show,
  setShow,
  title,
}) => {
  return (
    <Modal open={show}>
      <Box sx={dialogBoxStyle}>
        {error && (
          <Cancel sx={{ fontSize: { xs: 32, sm: 64 } }} color="error" />
        )}
        <Typography
          variant="h3"
          fontWeight={500}
          sx={{ fontSize: { xs: "20px", sm: "32px" } }}
        >
          {title}
        </Typography>
        <Button
          sx={dialogContainedButtonStyle}
          variant="contained"
          onClick={buttonAction}
        >
          {buttonTitle}
        </Button>
        <Button
          sx={dialogOutlinedButtonStyle}
          variant="outlined"
          onClick={() => setShow(false)}
        >
          Cancel
        </Button>
      </Box>
    </Modal>
  );
};

export default ConfirmationDialog;
